/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;padding:30px 20px 0 0}.left-filler[_ngcontent-%COMP%], .right-filler[_ngcontent-%COMP%]{flex:1 1 0}.right-filler[_ngcontent-%COMP%]{color:rgba(0,0,0,.38);display:flex;align-items:center;justify-content:flex-end}.right-filler[_ngcontent-%COMP%]   .close-container[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
